/**
 * @desc 详情查询
 */
import { MemberGroupEntity } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryMemberGroupParameter = {
  id?: string
}

const method = 'GET'
const url = '/auth/group'

export const queryMemberGroupApi = (
  params?: QueryMemberGroupParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<MemberGroupEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryMemberGroupApi.method = method
queryMemberGroupApi.url = url
